module.exports = __webpack_public_path__ + "img/sp.26e40ff7.png";